<app-olci-checkin-component
	id="checkin-olci-component"
	[isTravelQuestionnaireCompleted]="guestService.isTravelQuestionnaireCompleted | async"
	[isGuestDetailsCompleted]="guestService.isGuestDetailsCompleted() | async"
	[isOnboardExpensesCompleted]="guestService.isOnboardExpensesCompleted | async"
	[isCruiseDetailsCompleted]="guestService.isCruiseDetailsCompleted | async"
	[bundle]="resourceBundle.bundle | async"
	[screensize]="screensize$ | async"
>
</app-olci-checkin-component>
